var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import getTranslation from '../../../../strings/i18n';
import { getActivityTabAnalyticsProps } from '../../../../const/analytics';
import { StyledTitle } from '../../../../styles/text';
import { StyledTab } from '../subcomponents';
var NavbarTap = function (_a) {
    var tabId = _a.tabId, onClick = _a.onClick, activeTab = _a.activeTab;
    var t = getTranslation().t;
    var analyticsProps = getActivityTabAnalyticsProps()[tabId];
    var isActive = activeTab === "".concat(tabId);
    return (_jsx(StyledTab, __assign({ id: tabId, role: "tab", "aria-controls": "".concat(tabId, "-panel"), onClick: onClick, href: "#".concat(tabId), isActive: isActive, className: "ensightencustomevent" }, analyticsProps, { children: _jsx(StyledTitle, { color: "cyanBlue", lineHeight: 1.5, textTransform: "uppercase", children: t("navBar.".concat(tabId, "Button")) }) })));
};
export default NavbarTap;
//# sourceMappingURL=index.js.map